import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Anticipated Response of Change by Department',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Anticipated Response of Change',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Positive',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Advancement Communications / Marketing',
                                  y: {
                                    '#': {
                                      '@': 'positiveAdvancementCommunicationsMarketing',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Operations',
                                  y: {
                                    '#': {
                                      '@': 'positiveAdvancementOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Studies',
                                  y: {
                                    '#': {
                                      '@': 'positiveAdvancementStudies',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Engagement',
                                  y: {
                                    '#': {
                                      '@': 'positiveAlumniEngagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Relations',
                                  y: {
                                    '#': {
                                      '@': 'positiveAlumniRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Annual Giving',
                                  y: {
                                    '#': {
                                      '@': 'positiveAnnualGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Campaign Operations',
                                  y: {
                                    '#': {
                                      '@': 'positiveCampaignOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Corporate Resources',
                                  y: {
                                    '#': {
                                      '@': 'positiveCorporateResources',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development / Fundraising',
                                  y: {
                                    '#': {
                                      '@': 'positiveDevelopmentFundraising',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development',
                                  y: {
                                    '#': {
                                      '@': 'positiveDevelopment',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Donor Relations and Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'positiveDonorRelationsAndStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Foundation Relations',
                                  y: {
                                    '#': {
                                      '@': 'positiveFoundationRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Major Gifts',
                                  y: {
                                    '#': {
                                      '@': 'positiveMajorGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Planning Giving',
                                  y: {
                                    '#': {
                                      '@': 'positivePlanningGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Principal Gifts',
                                  y: {
                                    '#': {
                                      '@': 'positivePrincipalGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Development',
                                  y: {
                                    '#': {
                                      '@': 'positiveProspectDevelopment',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Neutral',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Advancement Communications / Marketing',
                                  y: {
                                    '#': {
                                      '@': 'neutralAdvancementCommunicationsMarketing',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Operations',
                                  y: {
                                    '#': {
                                      '@': 'neutralAdvancementOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Studies',
                                  y: {
                                    '#': {
                                      '@': 'neutralAdvancementStudies',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Engagement',
                                  y: {
                                    '#': {
                                      '@': 'neutralAlumniEngagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Relations',
                                  y: {
                                    '#': {
                                      '@': 'neutralAlumniRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Annual Giving',
                                  y: {
                                    '#': {
                                      '@': 'neutralAnnualGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Campaign Operations',
                                  y: {
                                    '#': {
                                      '@': 'neutralCampaignOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Corporate Resources',
                                  y: {
                                    '#': {
                                      '@': 'neutralCorporateResources',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development / Fundraising',
                                  y: {
                                    '#': {
                                      '@': 'neutralDevelopmentFundraising',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development',
                                  y: {
                                    '#': {
                                      '@': 'neutralDevelopment',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Donor Relations and Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'neutralDonorRelationsAndStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Foundation Relations',
                                  y: {
                                    '#': {
                                      '@': 'neutralFoundationRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Major Gifts',
                                  y: {
                                    '#': {
                                      '@': 'neutralMajorGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Planning Giving',
                                  y: {
                                    '#': {
                                      '@': 'neutralPlanningGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Principal Gifts',
                                  y: {
                                    '#': {
                                      '@': 'neutralPrincipalGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Development',
                                  y: {
                                    '#': {
                                      '@': 'neutralProspectDevelopment',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Negative',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Advancement Communications / Marketing',
                                  y: {
                                    '#': {
                                      '@': 'negativeAdvancementCommunicationsMarketing',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Operations',
                                  y: {
                                    '#': {
                                      '@': 'negativeAdvancementOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Studies',
                                  y: {
                                    '#': {
                                      '@': 'negativeAdvancementStudies',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Engagement',
                                  y: {
                                    '#': {
                                      '@': 'negativeAlumniEngagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Relations',
                                  y: {
                                    '#': {
                                      '@': 'negativeAlumniRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Annual Giving',
                                  y: {
                                    '#': {
                                      '@': 'negativeAnnualGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Campaign Operations',
                                  y: {
                                    '#': {
                                      '@': 'negativeCampaignOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Corporate Resources',
                                  y: {
                                    '#': {
                                      '@': 'negativeCorporateResources',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development / Fundraising',
                                  y: {
                                    '#': {
                                      '@': 'negativeDevelopmentFundraising',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development',
                                  y: {
                                    '#': {
                                      '@': 'negativeDevelopment',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Donor Relations and Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'negativeDonorRelationsAndStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Foundation Relations',
                                  y: {
                                    '#': {
                                      '@': 'negativeFoundationRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Major Gifts',
                                  y: {
                                    '#': {
                                      '@': 'negativeMajorGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Planning Giving',
                                  y: {
                                    '#': {
                                      '@': 'negativePlanningGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Principal Gifts',
                                  y: {
                                    '#': {
                                      '@': 'negativePrincipalGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Development',
                                  y: {
                                    '#': {
                                      '@': 'negativeProspectDevelopment',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Mixed',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Advancement Communications / Marketing',
                                  y: {
                                    '#': {
                                      '@': 'mixedAdvancementCommunicationsMarketing',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Operations',
                                  y: {
                                    '#': {
                                      '@': 'mixedAdvancementOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Studies',
                                  y: {
                                    '#': {
                                      '@': 'mixedAdvancementStudies',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Engagement',
                                  y: {
                                    '#': {
                                      '@': 'mixedAlumniEngagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Relations',
                                  y: {
                                    '#': {
                                      '@': 'mixedAlumniRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Annual Giving',
                                  y: {
                                    '#': {
                                      '@': 'mixedAnnualGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Campaign Operations',
                                  y: {
                                    '#': {
                                      '@': 'mixedCampaignOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Corporate Resources',
                                  y: {
                                    '#': {
                                      '@': 'mixedCorporateResources',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development / Fundraising',
                                  y: {
                                    '#': {
                                      '@': 'mixedDevelopmentFundraising',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development',
                                  y: {
                                    '#': {
                                      '@': 'mixedDevelopment',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Donor Relations and Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'mixedDonorRelationsAndStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Foundation Relations',
                                  y: {
                                    '#': {
                                      '@': 'mixedFoundationRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Major Gifts',
                                  y: {
                                    '#': {
                                      '@': 'mixedMajorGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Planning Giving',
                                  y: {
                                    '#': {
                                      '@': 'mixedPlanningGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Principal Gifts',
                                  y: {
                                    '#': {
                                      '@': 'mixedPrincipalGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Development',
                                  y: {
                                    '#': {
                                      '@': 'mixedProspectDevelopment',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Unknown',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Advancement Communications / Marketing',
                                  y: {
                                    '#': {
                                      '@': 'unknownAdvancementCommunicationsMarketing',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Operations',
                                  y: {
                                    '#': {
                                      '@': 'unknownAdvancementOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Studies',
                                  y: {
                                    '#': {
                                      '@': 'unknownAdvancementStudies',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Engagement',
                                  y: {
                                    '#': {
                                      '@': 'unknownAlumniEngagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Relations',
                                  y: {
                                    '#': {
                                      '@': 'unknownAlumniRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Annual Giving',
                                  y: {
                                    '#': {
                                      '@': 'unknownAnnualGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Campaign Operations',
                                  y: {
                                    '#': {
                                      '@': 'unknownCampaignOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Corporate Resources',
                                  y: {
                                    '#': {
                                      '@': 'unknownCorporateResources',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development / Fundraising',
                                  y: {
                                    '#': {
                                      '@': 'unknownDevelopmentFundraising',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development',
                                  y: {
                                    '#': {
                                      '@': 'unknownDevelopment',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Donor Relations and Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'unknownDonorRelationsAndStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Foundation Relations',
                                  y: {
                                    '#': {
                                      '@': 'unknownFoundationRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Major Gifts',
                                  y: {
                                    '#': {
                                      '@': 'unknownMajorGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Planning Giving',
                                  y: {
                                    '#': {
                                      '@': 'unknownPlanningGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Principal Gifts',
                                  y: {
                                    '#': {
                                      '@': 'unknownPrincipalGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Development',
                                  y: {
                                    '#': {
                                      '@': 'unknownProspectDevelopment',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Department',
                  yLabel: 'Count',
                },
              },
            ],
          },
          type: 'bar.stacked',
        },
      },
    },
  },
  subqueries: {
    mixedMajorGifts: {
      filter: {
        and: [
          {
            in: [
              'Major Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedAnnualGiving: {
      filter: {
        and: [
          {
            in: [
              'Annual Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralMajorGifts: {
      filter: {
        and: [
          {
            in: [
              'Major Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownMajorGifts: {
      filter: {
        and: [
          {
            in: [
              'Major Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeMajorGifts: {
      filter: {
        and: [
          {
            in: [
              'Major Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveMajorGifts: {
      filter: {
        and: [
          {
            in: [
              'Major Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedPlanningGiving: {
      filter: {
        and: [
          {
            in: [
              'Planning Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedPrincipalGifts: {
      filter: {
        and: [
          {
            in: [
              'Principal Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralAnnualGiving: {
      filter: {
        and: [
          {
            in: [
              'Annual Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownAnnualGiving: {
      filter: {
        and: [
          {
            in: [
              'Annual Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedAlumniRelations: {
      filter: {
        and: [
          {
            in: [
              'Alumni Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeAnnualGiving: {
      filter: {
        and: [
          {
            in: [
              'Annual Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveAnnualGiving: {
      filter: {
        and: [
          {
            in: [
              'Annual Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedAlumniEngagement: {
      filter: {
        and: [
          {
            in: [
              'Alumni Engagement',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralPlanningGiving: {
      filter: {
        and: [
          {
            in: [
              'Planning Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralPrincipalGifts: {
      filter: {
        and: [
          {
            in: [
              'Principal Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownPlanningGiving: {
      filter: {
        and: [
          {
            in: [
              'Planning Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownPrincipalGifts: {
      filter: {
        and: [
          {
            in: [
              'Principal Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativePlanningGiving: {
      filter: {
        and: [
          {
            in: [
              'Planning Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativePrincipalGifts: {
      filter: {
        and: [
          {
            in: [
              'Principal Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralAlumniRelations: {
      filter: {
        and: [
          {
            in: [
              'Alumni Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positivePlanningGiving: {
      filter: {
        and: [
          {
            in: [
              'Planning Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positivePrincipalGifts: {
      filter: {
        and: [
          {
            in: [
              'Principal Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownAlumniRelations: {
      filter: {
        and: [
          {
            in: [
              'Alumni Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedAdvancementStudies: {
      filter: {
        and: [
          {
            in: [
              'Advancement Studies',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedCampaignOperations: {
      filter: {
        and: [
          {
            in: [
              'Campaign Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedCorporateResources: {
      filter: {
        and: [
          {
            in: [
              'Corporate Resources',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeAlumniRelations: {
      filter: {
        and: [
          {
            in: [
              'Alumni Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralAlumniEngagement: {
      filter: {
        and: [
          {
            in: [
              'Alumni Engagement',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveAlumniRelations: {
      filter: {
        and: [
          {
            in: [
              'Alumni Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownAlumniEngagement: {
      filter: {
        and: [
          {
            in: [
              'Alumni Engagement',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedFoundationRelations: {
      filter: {
        and: [
          {
            in: [
              'Foundation Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedProspectDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Prospect Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeAlumniEngagement: {
      filter: {
        and: [
          {
            in: [
              'Alumni Engagement',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveAlumniEngagement: {
      filter: {
        and: [
          {
            in: [
              'Alumni Engagement',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralAdvancementStudies: {
      filter: {
        and: [
          {
            in: [
              'Advancement Studies',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralCampaignOperations: {
      filter: {
        and: [
          {
            in: [
              'Campaign Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralCorporateResources: {
      filter: {
        and: [
          {
            in: [
              'Corporate Resources',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownAdvancementStudies: {
      filter: {
        and: [
          {
            in: [
              'Advancement Studies',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownCampaignOperations: {
      filter: {
        and: [
          {
            in: [
              'Campaign Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownCorporateResources: {
      filter: {
        and: [
          {
            in: [
              'Corporate Resources',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedAdvancementOperations: {
      filter: {
        and: [
          {
            in: [
              'Advancement Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeAdvancementStudies: {
      filter: {
        and: [
          {
            in: [
              'Advancement Studies',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeCampaignOperations: {
      filter: {
        and: [
          {
            in: [
              'Campaign Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeCorporateResources: {
      filter: {
        and: [
          {
            in: [
              'Corporate Resources',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralFoundationRelations: {
      filter: {
        and: [
          {
            in: [
              'Foundation Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralProspectDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Prospect Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveAdvancementStudies: {
      filter: {
        and: [
          {
            in: [
              'Advancement Studies',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveCampaignOperations: {
      filter: {
        and: [
          {
            in: [
              'Campaign Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveCorporateResources: {
      filter: {
        and: [
          {
            in: [
              'Corporate Resources',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownFoundationRelations: {
      filter: {
        and: [
          {
            in: [
              'Foundation Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownProspectDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Prospect Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedDevelopmentFundraising: {
      filter: {
        and: [
          {
            in: [
              'Development / Fundraising',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeFoundationRelations: {
      filter: {
        and: [
          {
            in: [
              'Foundation Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeProspectDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Prospect Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveFoundationRelations: {
      filter: {
        and: [
          {
            in: [
              'Foundation Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveProspectDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Prospect Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralAdvancementOperations: {
      filter: {
        and: [
          {
            in: [
              'Advancement Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownAdvancementOperations: {
      filter: {
        and: [
          {
            in: [
              'Advancement Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeAdvancementOperations: {
      filter: {
        and: [
          {
            in: [
              'Advancement Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralDevelopmentFundraising: {
      filter: {
        and: [
          {
            in: [
              'Development / Fundraising',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveAdvancementOperations: {
      filter: {
        and: [
          {
            in: [
              'Advancement Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownDevelopmentFundraising: {
      filter: {
        and: [
          {
            in: [
              'Development / Fundraising',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeDevelopmentFundraising: {
      filter: {
        and: [
          {
            in: [
              'Development / Fundraising',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveDevelopmentFundraising: {
      filter: {
        and: [
          {
            in: [
              'Development / Fundraising',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedDonorRelationsAndStewardship: {
      filter: {
        and: [
          {
            in: [
              'Donor Relations and Stewardship',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralDonorRelationsAndStewardship: {
      filter: {
        and: [
          {
            in: [
              'Donor Relations and Stewardship',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownDonorRelationsAndStewardship: {
      filter: {
        and: [
          {
            in: [
              'Donor Relations and Stewardship',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeDonorRelationsAndStewardship: {
      filter: {
        and: [
          {
            in: [
              'Donor Relations and Stewardship',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveDonorRelationsAndStewardship: {
      filter: {
        and: [
          {
            in: [
              'Donor Relations and Stewardship',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedAdvancementCommunicationsMarketing: {
      filter: {
        and: [
          {
            in: [
              'Advancement Communications / Marketing',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralAdvancementCommunicationsMarketing: {
      filter: {
        and: [
          {
            in: [
              'Advancement Communications / Marketing',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownAdvancementCommunicationsMarketing: {
      filter: {
        and: [
          {
            in: [
              'Advancement Communications / Marketing',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeAdvancementCommunicationsMarketing: {
      filter: {
        and: [
          {
            in: [
              'Advancement Communications / Marketing',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveAdvancementCommunicationsMarketing: {
      filter: {
        and: [
          {
            in: [
              'Advancement Communications / Marketing',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
